<template>
  <BaseFrame
    :id="id"
    :idText='idText'
    submitText="提交"
    @submit='submit()'
    clearText=""
    @cancel='$router.push(-1)'
  >
    <div slot="content">
      <lk-card>
        <lk-form>
          <lk-form-item label="药品" style="padding: 10px 20px">
            <lk-row :gutter='16' v-show="!isEdit && !isClick">
              <lk-col span="8">
                <inputSearch  @selected='addGoods' :loading='goodsloading'  @getData='handleInputSearch'
                  style="width:256px" :autoFocus='true' :selectedList='drugTableData' :data='goodsData' :columns='goodsColumns'>
                </inputSearch>
              </lk-col>
            </lk-row>
          </lk-form-item>
          <lk-form-item style="marginBottom: 80px">
            <lk-row>
              <lk-table
                border
                :columns='drugColumns'
                :data='drugTableData'
              />
            </lk-row>
          </lk-form-item>
          <lk-form-item label="门店" style="padding: 10px 20px">
            <lk-button
              type='primary'
              @click="handleBtnClick"
              :disabled='!isClick'
            >新增</lk-button>
          </lk-form-item>
          <lk-form-item>
            <lk-table
              border
              :columns='storeColumns'
              :data='storeTableData'
            />
          </lk-form-item>
        </lk-form>
      </lk-card>
      <lk-modal
      width="900"
      title="添加门店"
      v-model="addStores"
      :mask-closable="false"
      @on-cancel="handleModalCancel">
      <div class="addContainer">
        <loading v-show="loading"></loading>
        <div class="queryStoreItem">
          <label>门店名称:</label>
          <storeListSelect class="searchStoreItem" v-model="query.storeIdList"></storeListSelect>
          <div class="searchStoreAction">
            <lk-button class="mr" type='primary' @click="handleSearchStore">查询</lk-button>
            <lk-button @click="clearSearchStore">重置</lk-button>
          </div>
        </div>
        <lk-table
          @on-select="handleTempSelect"
          @on-select-all="handleTempSelectAll"
          @on-select-cancel="handleTempCancel"
          border
          height="450"
          :columns="storesColumns"
          :data="storeAndAmountList">
        </lk-table>
      </div>
      <div slot="footer">
        <lk-button @click="handleModalCancel">取消</lk-button>
        <lk-button @click="confirmGoods" type="primary">确定</lk-button>
      </div>
    </lk-modal>
    </div>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import utils from '../../libs/utils';
import tools from '../../services/tools';
import loading from '../../components/LoadingSpan';
import InputSearch from '../../components/InputSearch.vue';
import goodsDropDownInput from '../../components/goods/goodsDropDownInput.vue';

export default {
  name: 'PharmaceuticalAdd',
  components: {
    loading,
    BaseFrame,
    InputSearch,
    goodsDropDownInput,
  },
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      idText: '',
      id: '',
      isEdit: false, // 是否可选择商品
      drugIdList: [], // 选择的商品id
      storeIdList: [], // 选择门店id
      query: {
        storeIdList: [],
      },
      allStoreAndAmountList: [],
      storeAndAmountList: [],
      selectedTempStoreIds: [], // 门店Idlist
      goodsData: [], // 搜索药品list
      templateList: [], // 随访模版信息
      goodsloading: false,
      loading: false,
      addStores: false,
      goodsColumns: [
        { title: '商品编码', key: 'serialCode', width: '65px' },
        { title: '药品通用名', key: 'approvedName', width: '142px' },
        { title: '商品名', key: 'goodsName', width: '90px' },
      ],
      selectData: [],
      drugTableData: [],

      storeTableData: [],
      goodsForm: {
        approvedDrugNames: '',
      },
      storesColumns: [
        {
          title: '选择',
          key: 'id',
          type: 'selection',
          width: 60,
        },
        {
          title: '门店',
          minWidth: 116,
          align: 'center',
          key: 'storeName',
        },
        {
          title: '库存',
          minWidth: 116,
          align: 'center',
          key: 'inventoryAmount',
          render: (h, { row }) => h('span', row.inventoryAmount ? row.inventoryAmount : 0),
        },
      ],
      storeColumns: [
        {
          title: '序号',
          minWidth: 116,
          align: 'center',
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '门店',
          minWidth: 116,
          align: 'center',
          key: 'storeName',
        },
        {
          title: '库存',
          minWidth: 116,
          align: 'center',
          key: 'inventoryAmount',
          render: (h, { row }) => h('span', row.inventoryAmount ? row.inventoryAmount : 0),
        },
        {
          title: '操作',
          minWidth: 116,
          align: 'center',
          render: (h, { row, index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.storeTableData.splice(index, 1);
              },
            },
          }, '删除'),
        },
      ],
      drugColumns: [
        {
          title: '药品编码',
          minWidth: 116,
          align: 'center',
          key: 'serialCode',
        },
        {
          title: '通用名',
          minWidth: 116,
          align: 'center',
          key: 'approvedName',
          render: (h, params) => h('span', this.isEdit ? params.row.approvedDrugNames : params.row.approvedName)
        },
        {
          title: '商品名',
          minWidth: 116,
          align: 'center',
          key: 'goodsName',
        },
        {
          title: '商品状态',
          minWidth: 116,
          align: 'center',
          render: (h, { row }) => h('div', row.status  == 1 ? '启用' : '禁用'),
        },
        {
          title: '随访模版ID',
          minWidth: 200,
          align: 'center',
          renderHeader:(h, params) => {
            return h('div', [
              h('span', {style:{ color: "#ed4014",marginLeft: '4px'}}, '*'),
              h('span','随访模版ID')
            ])
          },
          render: (h, params) => {
            const optionArr = this.templateList.map(item => h('lk-option', {
              props: {
                value: item.id,
              },
            }, `${item.id} ${item.name}`));
            let values = [];
            if (params.row.visitTemplates) {
              values = params.row.visitTemplates.map(item => item.templateId);
            }
            return h('div', [
              h('lk-select',
                {
                  props: {
                    value: values,
                    placeholder: '请选择',
                    transfer: true,
                    multiple: true,
                    filterable: true,
                  },
                  on: {
                    'on-change': (value) => {
                      const visitTemplates = [];
                      value.forEach((item) => {
                        const templateItem = this.templateList.filter(subItem => subItem.id == item);
                        if (templateItem.length) {
                          visitTemplates.push(
                            {
                              templateId: item,
                              templateName: templateItem[0].name,
                            },
                          );
                        }
                      });
                      this.drugTableData[params.index].templates = visitTemplates;
                    },
                  },
                }, optionArr)]);
          },
        },
        {
          title: '操作',
          minWidth: 116,
          align: 'center',
          render: (h, { row, index }) => h('lk-button', {
            props: {
              type: 'text',
              disabled: this.isEdit,
            },
            on: {
              click: () => {

                this.drugTableData.splice(index, 1);
                this.storeTableData = [];
              },
            },
          }, '删除'),
        },
      ],
    };
  },
  watch: {
  },
  computed: {
    isClick() {
      return this.drugTableData.length > 0;
    },
  },
  methods: {
    submit() {
      const storeIdList = this.storeTableData.map(item => item.storeId);
      this.drugIdList = this.drugTableData.map(item => item.id);
      const params = {
        storeIdList,
        goodsBaseId: this.drugIdList[0],
        visitTemplates: this.drugTableData[0].templates,
      };
      if (this.isEdit) {
        params.pharmaceuticalGoodsId = this.$route.query.rowData.id;
        params.goodsBaseId = this.$route.query.rowData.goodsBaseId;
      }
      // 药品，门店不能为空才能提交
      if (params.storeIdList.length === 0 || this.drugTableData.length === 0) {
        this.$Message.error('药品和门店不能为空');
      } else if (!(params.visitTemplates && params.visitTemplates.length)) {
        this.$Message.error('请选择随访模版');
      } else {
        tools.addAndEditPharmacy(params).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('提交成功');
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    selectedSaleId() {
      const res = [];
      this.info.forEach((item) => {
        item.id && res.push(item.id);
      });
      return res;
    },
    handleBtnClick() {
      this.drugIdList = this.drugTableData.map(item => item.id);
      const params = {
        goodsBaseId: this.isEdit ? this.$route.query.rowData.goodsBaseId : this.drugIdList[0],
      };
      tools.getStoreAndAmount(params).then((res) => {
        if (res.data.status === 200) {
          this.addStores = true;
          this.tempStoreList = [];
          this.selectedTempStoreIds = res.data.data.map(item => item.storeId); // 获取所有门店id集合
          const storeAndAmountList = res.data.data || [];
          const idList = this.storeTableData.map(item => item.storeId);
          storeAndAmountList.forEach((item) => {
            if (idList.indexOf(item.storeId) >= 0) {
              this.$nextTick(() => {
                this.$set(item, '_disabled', true);
                this.$set(item, '_checked', true);
              });
            } else {
              this.$set(item, '_checked', false);
              this.$set(item, '_disabled', false);
            }
          });
          this.allStoreAndAmountList = storeAndAmountList;
          this.storeAndAmountList = storeAndAmountList;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleModalCancel() {
      this.addStores = false;
      this.clearSearchStore();
    },
    handleTempSelect(selection, row) {
      this.tempStoreList.push(row);
    },
    handleTempSelectAll(selection, row) {
      const unCheckList = selection.filter(item => !item._checked);
      if (unCheckList && unCheckList.length > 0) {
        this.tempStoreList.push(...unCheckList);
      }
    },
    handleTempCancel(selection, row) {
      this.tempStoreList.forEach((item, index) => {
        if (item.storeId === row.storeId) {
          this.tempStoreList.splice(index, 1);
        }
      });
    },
    confirmGoods() {
      this.addStores = false;
      this.storeTableData.push(...this.tempStoreList);
      this.clearSearchStore();
    },
    addGoods(val) {
      this.drugTableData.push(val);
    },
    handleInputSearch(val) {
      console.log(val);
      this.goodsloading = true;
      this.goodsData = [];
      tools.getGoodsInfo({
        nameMix: val,
      }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data.length) {
            // 控制异步查询搜索词为空展示问题
            this.goodsData = res.data.data;
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.goodsloading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.goodsloading = false;
        console.log(err);
      });
    },
    getTemplateList() {
      tools.getTemplateList().then((res) => {
        if (res.data.status === 200) {
          this.templateList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clearSearchStore() {
      this.query = {
        storeIdList: [],
      };
      this.tempStoreList = [];
      this.storeAndAmountList = this.allStoreAndAmountList;
    },
    handleSearchStore() {
      if (this.query.storeIdList.length === 0) {
        this.clearSearchStore();
        return;
      }
      this.tempStoreList = [];
      this.storeAndAmountList = this.allStoreAndAmountList.filter(item => this.query.storeIdList.find(child => child == item.storeId));
    },
  },
  mounted() {
    const { edit, rowData } = this.$route.query;
    this.isEdit = edit == 1;
    if (this.isEdit) {
      this.drugTableData.push(rowData);
      if (rowData.storeAndAmountList && rowData.storeAndAmountList.length > 0) {
        this.storeTableData.push(...rowData.storeAndAmountList);
      }
    }
    this.getTemplateList();
  },
};
</script>
<style lang="less" scoped>
.IDRequired:before{
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 12px;
  color: #ed4014;
}

.queryStoreItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  .searchStoreItem {
    margin-left: 10px;
    flex: 1;
  }
  .searchStoreAction {
    margin-left: 10px;
  }
  .mr {
    margin-right: 10px;
  }
}

</style>
